<template>
  <div class="tab-pane" id="dtab6" role="tabpanel">
    <modal-popup :btn-delete="true" @delete="deleteText" :loading="loading" v-if="show_popup" @close="show_popup = false" @save="updateText" modal-width="col-md-5 col-lg-4">
      <template v-slot:modal-title>
        <h4 class="text-dark font-weight-bold">Textbaustein bearbeiten</h4>
      </template>
      <div class="form-group mb-0 mr-2">
        <textarea rows="5" class="form-control" v-model="text_content"></textarea>
      </div>
      <template #delete-text>Textbaustein löschen</template>
      <template #save-text>Speichern</template>
    </modal-popup>

    <div class="mb-3">
      <h3>Textbausteine</h3>
      <div class="search-bar">
        <div class="form-group col-md-7 pl-0">
          <img class="form-control-feedback pb-1 search-img position-absolute" src="@/assets/images/search.png" alt="icon" style="right: 20px;padding: 7px!important;">
          <input type="text" v-model="qry" class="form-control form-control-sm" placeholder="Textbausteine suchen">
        </div>
        <div class="text-list">
          <div v-show="loading" class="spinner-border spinner-border-sm"></div>
          <div v-show="!loading" v-for="(text, i) in textList" :key="i" class="text-list-item d-inline-block rounded mb-2 mr-2">
           <button @click="setGroupText(text.crtagname)" class="mr-2">{{text.crtagname}}</button>
            <i class="fa fa-edit float-right" @click="editText(text)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModalPopup from "../../../custom/ModalPopup";
export default {
  components: {ModalPopup},
  data(){
    return {
      qry: "",
      show_popup: false,
      loading: false,
      text_content: "",
      selected_val: {}
    }
  },
  computed: {
    activeGroupId(){
      return this.$store.state.constructionDiary.activeTextGroupId
    },
    textList(){
      return this.$store.state.constructionDiary.groupTextList.filter(item => item.crtagname.toLowerCase().includes(this.qry.toLowerCase()))
    }
  },
  methods: {
    editText(val){
      this.selected_val = val
      this.text_content = val.crtagname
      this.show_popup = true
    },
    async updateText(is_delete = 0){
      this.loading = true
      const id = this.selected_val.crtagid
      const payload = { project_id: this.$route.params.id, text_id: id, text: this.text_content, is_delete }
      await this.$store.dispatch('updateOrCreateText',payload);
      this.loading = this.show_popup = false;
    },
    async deleteText(){
     await this.updateText(1)
    },
    setGroupText(txt){
      this.$store.commit("setActiveTextValue",txt)
    }
  },
  watch: {
    activeGroupId: function (val){
      this.loading = true
      this.$store.dispatch('getTextList',[this.$route.params.id,val]).finally(() => {
        this.loading = false
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/SideBar/ConstructionTextModuleTab.vue